const ACCOUNT_ID_PATTERN = /\/accounts\/(\d+)\//;
const DEFAULT_SCOPE = 'default';

let overrideScope: string | null = null;

export const setRecommendationsScope = (accountId: string | number | null | undefined): void => {
  overrideScope = accountId === null || accountId === undefined || accountId === '' ? null : String(accountId);
};

export const getRecommendationsScope = (): string => {
  const fromPath = typeof window === 'undefined' ? null : window.location.pathname.match(ACCOUNT_ID_PATTERN)?.[1];
  return fromPath ?? overrideScope ?? DEFAULT_SCOPE;
};

// Stable identity for a scoped vendor set, used for both a component remount `key`
// and the recommendations cache key. Sorted so the two callers can never diverge.
// The comparator is explicit (not a bare `.sort()`) and deliberately NOT numeric:
// these ids are opaque here, and plain collation keeps the ordering the already
// persisted localStorage cache keys were written with.
export const scopeKey = (eventVendorIds: Array<string | number>): string =>
  eventVendorIds
    .map((id) => String(id))
    .sort((a, b) => a.localeCompare(b))
    .join('-');
